'use strict';

import React from 'react';
import { Home, AutoGraph, Download, ScatterPlot, BarChart } from '@mui/icons-material';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import { Microscope, BarChart4, Compass, Home as HomeLucide } from 'lucide-react';
import { getDiscoveryPanelNavLucideIcon, getDiscoveryPanelProductTypeIcon } from '@/features/discoveryPanels/useDiscoveryPanelEntries';
import { PROJECT_TOOL_IDS } from './projectToolTypes';

/** MUI icon for landing cards / Explore (non-sidebar). */
export function getProjectToolMuiIcon(tool) {
	if (tool.kind === 'discovery' && tool.productType) {
		return getDiscoveryPanelProductTypeIcon(tool.productType);
	}
	switch (tool.id) {
		case PROJECT_TOOL_IDS.HOME:
			return <Home />;
		case PROJECT_TOOL_IDS.RESULTS:
			return <Download />;
		case PROJECT_TOOL_IDS.RESULTS_DELIVERABLES:
			return <FilePresentOutlinedIcon />;
		case PROJECT_TOOL_IDS.RESULTS_SPECTRAL:
			return <FolderZipOutlinedIcon />;
		case PROJECT_TOOL_IDS.PATHWAYS:
			return <ScatterPlot />;
		case PROJECT_TOOL_IDS.STATS:
			return <BarChart />;
		case PROJECT_TOOL_IDS.IBP:
			return <AutoGraph />;
		default:
			return <Home />;
	}
}

/** Lucide icon for project sidebar top-level items. */
export function getProjectToolSidebarLucideIcon(tool) {
	if (tool.kind === 'discovery' && tool.productType) {
		return getDiscoveryPanelNavLucideIcon(tool.productType);
	}
	switch (tool.id) {
		case PROJECT_TOOL_IDS.HOME:
			return HomeLucide;
		case PROJECT_TOOL_IDS.RESULTS:
			return Microscope;
		case PROJECT_TOOL_IDS.PATHWAYS:
			return Compass;
		case PROJECT_TOOL_IDS.STATS:
			return BarChart4;
		default:
			return HomeLucide;
	}
}

/** MUI icons for sidebar Results submenu (matches prior Project.jsx). */
export function getProjectToolSidebarChildMuiIcon(childTool) {
	if (childTool.id === PROJECT_TOOL_IDS.RESULTS_DELIVERABLES) {
		return FilePresentOutlinedIcon;
	}
	if (childTool.id === PROJECT_TOOL_IDS.RESULTS_SPECTRAL) {
		return FolderZipOutlinedIcon;
	}
	return FilePresentOutlinedIcon;
}
